"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const VideoWrap = app_1.styled.div `
  padding: 50% 0 0 0;
  position: relative;
  height: 100%;
  width: 100%;
`;
const StyledFrame = app_1.styled.iframe `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
function Video({ source, id, className }) {
    const src = source === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?&title=0&byline=0&portrait=0`
        : `https://www.youtube.com/embed/${id}`;
    return ((0, jsx_runtime_1.jsx)(VideoWrap, Object.assign({}, (0, utils_1.exclude)({ className }, undefined), { children: (0, jsx_runtime_1.jsx)(StyledFrame, { title: "video", src: src, frameBorder: "0", allow: "autoplay; fullscreen; picture-in-picture", allowFullScreen: true }) })));
}
exports.Video = Video;
